/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdditionalServiceGroupInfoSaveReqVo
 */
export interface AdditionalServiceGroupInfoSaveReqVo {
    /**
     * 账单类型
     * @type {number}
     * @memberof AdditionalServiceGroupInfoSaveReqVo
     */
    billType: number;
    /**
     * 账单类型的附加服务组id [1,2,3,4]
     * @type {Array<number>}
     * @memberof AdditionalServiceGroupInfoSaveReqVo
     */
    serviceGroupIds: Array<number>;
    /**
     * 仓库id
     * @type {number}
     * @memberof AdditionalServiceGroupInfoSaveReqVo
     */
    warehouseId: number;
}

/**
 * Check if a given object implements the AdditionalServiceGroupInfoSaveReqVo interface.
 */
export function instanceOfAdditionalServiceGroupInfoSaveReqVo(value: object): value is AdditionalServiceGroupInfoSaveReqVo {
    if (!('billType' in value) || value['billType'] === undefined) return false;
    if (!('serviceGroupIds' in value) || value['serviceGroupIds'] === undefined) return false;
    if (!('warehouseId' in value) || value['warehouseId'] === undefined) return false;
    return true;
}

export function AdditionalServiceGroupInfoSaveReqVoFromJSON(json: any): AdditionalServiceGroupInfoSaveReqVo {
    return AdditionalServiceGroupInfoSaveReqVoFromJSONTyped(json, false);
}

export function AdditionalServiceGroupInfoSaveReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdditionalServiceGroupInfoSaveReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'billType': json['billType'],
        'serviceGroupIds': json['serviceGroupIds'],
        'warehouseId': json['warehouseId'],
    };
}

export function AdditionalServiceGroupInfoSaveReqVoToJSON(json: any): AdditionalServiceGroupInfoSaveReqVo {
    return AdditionalServiceGroupInfoSaveReqVoToJSONTyped(json, false);
}

export function AdditionalServiceGroupInfoSaveReqVoToJSONTyped(value?: AdditionalServiceGroupInfoSaveReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billType': value['billType'],
        'serviceGroupIds': value['serviceGroupIds'],
        'warehouseId': value['warehouseId'],
    };
}

